const highlights = [
  {
    icon: 'ri-arrow-left-right-line',
    title: '反差双主角',
    text: '张扬辣妹 × 内向漫画宅，两个世界的人被迫住进同一个屋檐，火花与笑料齐飞。',
  },
  {
    icon: 'ri-community-line',
    title: '同住日常',
    text: '一起吃饭、一起追更、一起熬夜看新刊，平凡的日常正是感情生根发芽的土壤。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '甜蜜心动',
    text: '从"寄居"到"在意"，在磨合与默契中，慢慢读懂彼此真实的心意。',
  },
];

export default function StoryIntro() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="container-site">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
            故事讲什么
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-3xl">一部从"借住"开始的恋爱喜剧</h2>
          <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base">
            故事没有宏大的世界观，它的魅力恰恰来自生活本身——两个性格迥异的高中生，在同一屋檐下
            从互相看不顺眼，到慢慢成为彼此最在意的人。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {highlights.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-700">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}